import { get, has } from 'lodash'
import axios from 'axios'
import ImageCrud from './ImageCrud.class'
import { REMOVE_IMAGE } from './constans'

const baseURL = '/api/seo/'

export default class Seo {
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()
		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {})	{
		if (!init) return

		this.id = get(init, 'id') ? init.id : null
		this.model_type = get(init, 'model_type') ? init.model_type : ''
		this.model_id = get(init, 'model_id') ? init.model_id : null
		this.title = get(init, 'title') ? init.title : ''
		this.description = get(init, 'description') ? init.description : ''
		this.keywords = get(init, 'keywords') ? init.keywords : ''
		this.og_title = get(init, 'og_title') ? init.og_title : ''
		this.og_description = get(init, 'og_description') ? init.og_description : ''
		this.og_url = get(init, 'og_url') ? init.og_url : ''
		this.og_image = get(init, 'og_image') ? new ImageCrud(init.og_image) : new ImageCrud()
		this.new_og_image = null

		// not request
		this.created_at = get(init, 'created_at') && this.isValidDate(init.created_at) ? new Date(init.created_at) : null
		this.updated_at = get(init, 'updated_at') && this.isValidDate(init.updated_at) ? new Date(init.updated_at) : null
		this.deleted_at = get(init, 'deleted_at') && this.isValidDate(init.deleted_at) ? new Date(init.deleted_at) : null
		this.errors = {}
	}

	async getSingle () {
		try {
			const {data} = await axios.get(`${baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}

	get formData () {
		const formData = new FormData()

		formData.append('model_type', this.model_type)
		formData.append('model_id', this.model_id)
		formData.append('title', this.title)
		formData.append('description', this.description)
		formData.append('keywords', this.keywords)
		formData.append('og_title', this.og_title)
		formData.append('og_description', this.og_description)
		formData.append('og_url', this.og_url)

		if (this.new_og_image) {
			if (this.new_og_image === REMOVE_IMAGE) {
				formData.append('og_image', '')
			} else {
				formData.append('og_image', this.new_og_image)
			}
		}

		return formData
	}

	save () {
		let url
		if (this.id) {
			url = `${baseURL}${this.id}` // for update request
		}	else {
			url = `${baseURL}` // for create request
		}

		return axios.post(url, this.formData)
			.then(({data, status}) => {
				if (status < 300) {
					this.setDefaultData(data.data)
				}
			})
			.catch(({response}) => {
				if (response.status === 422 && has(response, 'data.errors')) {
					this.createErrors(response.data.errors)
				}
			})
	}

	isValidDate (date) {
		return date && isNaN(date)
	}

	createErrors (obj) {
		let newObj = {}
		for (let key in obj) {
			const newErrorStr = obj[key].reduce((accumulator, item) => {
				return accumulator + item
			}, '')

			newObj[key] = newErrorStr
		}
		this.errors = newObj
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Seo.class.js